import { Contrast } from "../../types/general.types";
import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
const { size, color } = ids || {};
const getStyleType = (fixedButtonType) => {
    switch (fixedButtonType) {
        case "sided":
            return css `
        align-items: center;
        gap: ${size.general.ids_size_general_16x};
      `;
        case "pilled":
            return css `
        flex-direction: column;
        gap: ${size.general.ids_size_general_12x};
      `;
        default:
            css `
        align-items: center;
      `;
    }
};
const getStyleContrast = (filledBg, contrast) => {
    if (filledBg && contrast === Contrast.default) {
        return css `
      background: ${color.backgrounds.ids_color_bg_base};
    `;
    }
    return css `
    background: transparent;
  `;
};
export const FixedButtonAbsoluteContainer = styled.div `
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
`;
export const FixedButtonContainer = styled.div `
  padding: ${size.general.ids_size_general_24x};
  display: flex;
  ${({ fixedButtonType }) => getStyleType(fixedButtonType)}
  ${({ filledBg, contrast }) => getStyleContrast(filledBg || false, contrast)}
  button {
    width: 100%;
    ${({ fixedButtonType }) => {
    if (fixedButtonType === "primary")
        return css `
          justify-content: space-between;
        `;
}};
  }
`;
//# sourceMappingURL=FixedButton.style.js.map